export function matchMarkdownHeadingLine(line = '') {
  return String(line || '').match(/^(#{1,6})\s+(.+)$/);
}

export function isMarkdownHeadingLine(line = '') {
  return Boolean(matchMarkdownHeadingLine(line));
}
